<!--===============================
=            FILEINPUT            =
================================-->
<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">File Inputs</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple</div>
          <div slot="card-body">
            <div>
              <v-file-input multiple label="File input"></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Accept formats</div>
          <div slot="card-body">
            <div>
              <v-file-input accept="image/*" label="File input"></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">With chips</div>
          <div slot="card-body">
            <div>
              <div>
                <v-file-input chips multiple label="File input w/ chips"></v-file-input>
                <v-file-input small-chips multiple label="File input w/ small chips"></v-file-input>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters></v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Size displaying</div>
          <div slot="card-body">
            <div>
              <v-file-input show-size label="File input"></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Counter</div>
          <div slot="card-body">
            <div>
              <v-file-input show-size counter multiple label="File input"></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Dense</div>
          <div slot="card-body">
            <div>
              <v-file-input label="File input" outlined dense></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom icons</div>
          <div slot="card-body">
            <div>
              <v-file-input label="File input" filled prepend-icon="mdi-camera"></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Selection slot</div>
          <div slot="card-body">
            <div>
              <v-file-input
                v-model="files"
                placeholder="Upload your documents"
                label="File input"
                multiple
                prepend-icon="mdi-paperclip"
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Validation</div>
          <div slot="card-body">
            <div>
              <v-file-input
                :rules="rules"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Pick an avatar"
                prepend-icon="mdi-camera"
                label="Avatar"
              ></v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>

      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Complex selection slots</div>
          <div slot="card-body">
            <div>
              <v-file-input
                v-model="files"
                color="deep-purple accent-4"
                counter
                label="File input"
                multiple
                placeholder="Select your files"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip>

                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >+{{ files.length - 2 }} File(s)</span>
                </template>
              </v-file-input>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data: () => ({
    files: [],
    rules: [
      value =>
        !value ||
        value.size < 2000000 ||
        "Avatar size should be less than 2 MB!"
    ]
  })
};
</script>


<!--====  End of FILEINPUT  ====-->
